import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'integrations';

// Action Types
export const types = {
  GET_INTEGRATIONS: createAsyncTypes(`${KEY}/GET_INTEGRATIONS`),
  CREATE_INTEGRATION: createAsyncTypes(`${KEY}/CREATE_INTEGRATION`),
  UPDATE_INTEGRATION: createAsyncTypes(`${KEY}/UPDATE_INTEGRATION`),
  DELETE_INTEGRATION: createAsyncTypes(`${KEY}/DELETE_INTEGRATION`),
  RESET_ACTION: `${KEY}/RESET_ACTION`,
  RESET_ERROR: `${KEY}/RESET_ERROR`
};

export interface Integration {
  readonly id: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly name: string;
  readonly code: string;
}

export interface IntegrationsState {
  readonly integrations: Integration[];
  readonly createdIntegration: Integration | null;
  readonly action: {
    readonly pending: boolean;
    readonly success: boolean;
    readonly error: string | null;
    readonly errorCode: string | null;
  };
}

export interface CreateIntegrationPayload {
  name: string;
  code: string;
}

export interface UpdateIntegrationPayload {
  id: string;
  name: string;
  code?: string;
}

export interface GetIntegrationsRequest {
  type: typeof types.GET_INTEGRATIONS.REQUEST;
}

export interface GetIntegrationsError {
  type: typeof types.GET_INTEGRATIONS.ERROR;
  payload: string;
}

export interface GetIntegrationsPending {
  type: typeof types.GET_INTEGRATIONS.PENDING;
  payload: boolean;
}

export interface GetIntegrationsSuccess {
  type: typeof types.GET_INTEGRATIONS.SUCCESS;
  payload: Integration[];
}

export interface CreateIntegrationRequest {
  type: typeof types.CREATE_INTEGRATION.REQUEST;
  payload: CreateIntegrationPayload;
}

export interface CreateIntegrationPending {
  type: typeof types.CREATE_INTEGRATION.PENDING;
  payload: boolean;
}

export interface CreateIntegrationSuccess {
  type: typeof types.CREATE_INTEGRATION.SUCCESS;
  payload: Integration;
}

export interface CreateIntegrationError {
  type: typeof types.CREATE_INTEGRATION.ERROR;
  payload: string;
}

export interface UpdateIntegrationRequest {
  type: typeof types.UPDATE_INTEGRATION.REQUEST;
  payload: UpdateIntegrationPayload;
}

export interface UpdateIntegrationPending {
  type: typeof types.UPDATE_INTEGRATION.PENDING;
  payload: boolean;
}

export interface UpdateIntegrationSuccess {
  type: typeof types.UPDATE_INTEGRATION.SUCCESS;
  payload: Integration;
}

export interface UpdateIntegrationError {
  type: typeof types.UPDATE_INTEGRATION.ERROR;
  payload: string;
}

export interface DeleteIntegrationRequest {
  type: typeof types.DELETE_INTEGRATION.REQUEST;
  payload: { id: string };
}

export interface DeleteIntegrationPending {
  type: typeof types.DELETE_INTEGRATION.PENDING;
  payload: boolean;
}

export interface DeleteIntegrationSuccess {
  type: typeof types.DELETE_INTEGRATION.SUCCESS;
  payload: boolean;
}

export interface DeleteIntegrationError {
  type: typeof types.DELETE_INTEGRATION.ERROR;
  payload: {
    errorMessage: string;
    errorCode?: string;
  };
}

export type IntegrationsActionTypes =
  | GetIntegrationsRequest
  | GetIntegrationsSuccess
  | GetIntegrationsError
  | GetIntegrationsPending
  | CreateIntegrationRequest
  | CreateIntegrationPending
  | CreateIntegrationSuccess
  | CreateIntegrationError
  | UpdateIntegrationRequest
  | UpdateIntegrationPending
  | UpdateIntegrationSuccess
  | UpdateIntegrationError
  | DeleteIntegrationRequest
  | DeleteIntegrationPending
  | DeleteIntegrationSuccess
  | DeleteIntegrationError;
